module.exports = __webpack_public_path__ + "static/media/master_promotion_02.34fd3216.jpg";